import { generarParamsOportunidad } from '../../core/utils';
import { apiActualizarOportunidad, apiEmitirPoliza } from '../../services/apis';

export const usePago = (
  dataCotizar,
  formaPagoRef,
  setAlert,
  setCargando,
  recaptchaRef,
  plan,
  idOportunidad,
  idCotizacion,
  setModal,
  setTituloLoader,
) => {
  const pasoEmision = async () => {
    try {
      setModal(false);
      setTituloLoader({
        titulo: 'Emitiendo póliza...',
        subtitulo: 'Pago pendiente',
        estiloTitulo: 'text-center text-primary text-lg fontPSemiBold',
        estiloSubtitulo: 'text-center text-md',
      });
      setCargando(true);
      const requisitosCodigos = { AEP: '', DDP: '', DDPO: '' };
      let infoPoliza = '';
      const token = await recaptchaRef.current.executeAsync();

      if (dataCotizar.seguro.codigo === 'SEG-ONC') {
        requisitosCodigos.AEP = 'aceptado';
        requisitosCodigos.DDP = 'aceptado';
        requisitosCodigos.DDPO = 'aceptado';
      } else {
        requisitosCodigos.AEP = 'aceptado';
        requisitosCodigos.DDP = 'aceptado';
      }

      if (token) {
        //*generar poliza
        const paramsEmisionPoliza = {
          plan: { _id: plan._id },
          dataPersonal: { ...dataCotizar.datosPersonales, genero: dataCotizar.dataSeguro?.genero },
          dataSeguro: dataCotizar.dataSeguro,
          cotizacion: dataCotizar.cotizacion,
          seguro: dataCotizar.seguro,
          oportunidadId: idOportunidad,
          tokenReCaptcha: token,
          formaPago: formaPagoRef.current,
        };

        try {
          const { data: dataPoliza, success, message: messageError } = await apiEmitirPoliza(paramsEmisionPoliza);
          const formaPago = formaPagoRef.current;
          if (success) {
            setTituloLoader({
              titulo: 'Póliza emitida ✅',
              subtitulo: 'Realizando pago...',
              estiloTitulo: 'text-center text-sm text-primary fontPSemiBold',
              estiloSubtitulo: 'text-center text-primary text-lg fontPSemiBold',
            });
            let paramsOportunidad = generarParamsOportunidad(
              idOportunidad,
              idCotizacion,
              'En espera la confirmación de pago para finalizar la emisión de la póliza.',
              'COTIZADOR',
              'PAG',
              'EMI',
              {
                poliza: dataPoliza.numeroPoliza,
              },
            );

            paramsOportunidad = {
              ...paramsOportunidad,
              formaPagoSelect: formaPago,
            };

            infoPoliza = dataPoliza.numeroPoliza;

            const newParamsOportunidad = {
              ...paramsOportunidad,
              datosPersonales: dataCotizar?.datosPersonales,
            };

            await apiActualizarOportunidad(newParamsOportunidad);
          } //en caso de que la poliza no se realizo correctamente
          else {
            setCargando(false);
            setAlert({
              title: dataPoliza?.response?.data?.error ?? 'Error',
              description: messageError || "Ha ocurrido un error al emitir la póliza",
              severity: 'error',
            });
            setModal(true);

            const paramsOportunidad = generarParamsOportunidad(
              idOportunidad,
              idCotizacion,
              'Hubo un error al emitir la póliza',
              'ERROR',
              'EMI',
              'EMI',
              requisitosCodigos,
            );

            const newParamsOportunidad = {
              ...paramsOportunidad,
              datosPersonales: dataCotizar?.datosPersonales,
            };

            await apiActualizarOportunidad(newParamsOportunidad);
          }
        } catch (error) {
          setCargando(false);
          setAlert({
            title: 'Error',
            description: 'Ha ocurrido un error al emitir la póliza',
            severity: 'error',
          });
          setModal(true);

          const paramsOportunidad = generarParamsOportunidad(
            idOportunidad,
            idCotizacion,
            'Hubo un error al emitir la póliza',
            'ERROR',
            'EMI',
            'EMI',
            requisitosCodigos,
          );

          const newParamsOportunidad = {
            ...paramsOportunidad,
            datosPersonales: dataCotizar?.datosPersonales,
          };

          await apiActualizarOportunidad(newParamsOportunidad);
        }

        //* quiere decir que le emision de la poliza se realizo correctamente y luego se avanza al paso de pago
      }

      return infoPoliza;
    } catch (error) {
      setCargando(false);
      console.error(error);
    }
  };

  return pasoEmision;
};
